"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateToMonthNameString = transformDateToMonthNameString;
const monthNames_1 = require("../utils/monthNames");
function transformDateToMonthNameString(date) {
    return monthNames_1.monthNames[date.getUTCMonth()];
}
//# sourceMappingURL=transformDateToMonthNameString.js.map